// Module
var code = `<form-status-popover></form-status-popover> `;
// Exports
var _module_exports =code;;
var path = '/features/eventRegistrations/formStatusPopover.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;